"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.form = exports.action = exports.button = exports.supportForm = exports.support = exports.paragraph = exports.h6 = exports.h5 = exports.h4 = exports.h3 = exports.h2 = exports.h1 = exports.weight = void 0;

var _core = require("@emotion/core");

const typography = (theme, name) => {
  const family = theme[`b${name}FontFamily`];
  const familyFallback = theme[`b${name}FallbackFontFamily`];
  const size = theme[`b${name}FontSize`];
  const weight = theme[`b${name}FontWeight`];
  const height = theme[`b${name}LineHeight`];
  return (0, _core.css)`
    font-family: ${family}, ${familyFallback};
    font-size: ${size};
    font-weight: ${weight};
    line-height: ${height};
  `;
};

const weight = {
  light: () => (0, _core.css)`
    font-weight: 300;
  `,
  semiBold: () => (0, _core.css)`
    font-weight: 600;
  `,
  bold: () => (0, _core.css)`
    font-weight: 700;
  `
};
exports.weight = weight;

const h1 = theme => (0, _core.css)`
  ${typography(theme, 'Headingh1')}
`;

exports.h1 = h1;

const h2 = theme => (0, _core.css)`
  ${typography(theme, 'Headingh2')}
`;

exports.h2 = h2;

const h3 = theme => (0, _core.css)`
  ${typography(theme, 'Headingh3')}
`;

exports.h3 = h3;

const h4 = theme => (0, _core.css)`
  ${typography(theme, 'Headingh4')}
`;

exports.h4 = h4;

const h5 = theme => (0, _core.css)`
  ${typography(theme, 'Headingh5')}
`;

exports.h5 = h5;

const h6 = theme => (0, _core.css)`
  ${typography(theme, 'Headingh6')}
`;

exports.h6 = h6;

const paragraph = theme => (0, _core.css)`
  ${typography(theme, 'Textparagraph')}
`;

exports.paragraph = paragraph;

const support = theme => (0, _core.css)`
  ${typography(theme, 'Textsupport')}
`;

exports.support = support;

const supportForm = theme => (0, _core.css)`
  ${typography(theme, 'Textsupportform')}
`;

exports.supportForm = supportForm;

const button = theme => (0, _core.css)`
  ${typography(theme, 'Labelbutton')}
`;

exports.button = button;

const action = theme => (0, _core.css)`
  ${typography(theme, 'Labelaction')}
`;

exports.action = action;

const form = theme => (0, _core.css)`
  ${typography(theme, 'Labelform')}
`;

exports.form = form;